import { AxiosResponse } from 'axios';
import axios from 'lib/axios';

export interface SubscriptionByProcessData {
  subscriptionId: number;
  name: string;
  subscriptionName: string;
  credits: number;
  usedCredits: number;
  companyId: number;
  subscription_company_id: number;
  state: boolean;
  start_date: string;
  expiration_date: string;
  creditsAvailable: number;
  formatted_state: boolean;
}

export interface GetSubscriptionByProcessResponse {
  status: 'success' | 'error';
  error?: any;
  data: SubscriptionByProcessData;
}

/**
 * Obtiene la información de la suscripción asociada a un proceso específico
 * @param processId ID del proceso
 * @returns Información de la suscripción
 */
async function getSubscriptionByProcess(processId: number | string): Promise<GetSubscriptionByProcessResponse> {
  const PATH = `/subscription/process/${processId}`;

  try {
    const response: AxiosResponse<GetSubscriptionByProcessResponse> = await axios.get(PATH);
    return response.data;
  } catch (error) {
    console.error('Error al obtener la suscripción del proceso', error);
    return {
      status: 'error',
      error,
      data: {} as SubscriptionByProcessData
    };
  }
}

export default getSubscriptionByProcess;
